import React, { useMemo } from 'react';
import { CHILD_AGE_PLACEHOLDER, BED_REQUIRED_ENUM, PAX_CONFIG } from '../../../Constant/constants';

const MAX_CHILD_AGE = PAX_CONFIG.maxChildAge;
const ALLOWED_AGES = Array(MAX_CHILD_AGE + 1)
  .fill(1)
  .map((n, index) => index);
const AddChildrenAge = ({ ages, handleChange }) => {
  const handleAgeChange = (index, value) => {
    const updatedAges = ages.map((age, i) => (i === index ? value : age));
    handleChange(updatedAges);
  };

  return (
    <ul className="children-age-container">
      {ages.map((age, index) => (
        <React.Fragment key={index}>
          <li
            key={`${age}_${index}`}
            className="children-age-wrapper"
            data-testid="child-age-scale"
          >
            <span>{`Age of Child ${index + 1}`}</span>
            <ul className="font12 darkText childAge-selector-scale">
              {ALLOWED_AGES.map((count, index1) => (
                <li
                  className={`${ages[index] === count ? 'selected' : ''}`}
                  key={index1}
                  onClick={() => handleAgeChange(index, Number(count))}
                >
                  {count}
                </li>
              ))}
            </ul>
          </li>
        </React.Fragment>
      ))}
    </ul>
  );
};

export default AddChildrenAge;
